import type { QueryClient } from '@/api/zustandQuery';

type Row = Record<string, unknown>;
export function isSupplierReturn(payload: unknown): payload is Row {
  if (!payload || typeof payload !== 'object') return false;
  const row = payload as Row, metadata = (row.metadata ?? {}) as Row;
  return row.intakeStatus === 'RETURNED' || row.releaseStatus === 'CHANGES_REQUESTED' || metadata.approvalStatus === 'changes_requested';
}

/** Cancel captured reads before evicting supplier-only work; late responses cannot restore it. */
export function evictReturnedListing(client: QueryClient, payload: unknown): void {
  if (!isSupplierReturn(payload) || typeof payload.id !== 'string') return;
  const id = payload.id;
  const prefixes = [['page', 'image-builder'], ['page', 'video-slideshow-builder'], ['page', 'content-workbench'],
    ['page', 'listing-intake'], ['final-approval-queue']];
  for (const queryKey of prefixes) {
    void client.cancelQueries({ queryKey });
    client.setQueriesData<Row>({ queryKey }, previous => {
      if (!previous) return previous;
      const next = { ...previous };
      for (const field of ['listings', 'listingIndex', 'items', 'records', 'index']) {
        if (Array.isArray(next[field])) next[field] = (next[field] as Row[]).filter(row => row.id !== id && row.listingId !== id);
      }
      if (Array.isArray(next.projects)) next.projects = (next.projects as Row[]).map(project => {
        const settings = (project.settings ?? {}) as Row;
        return { ...project, settings: { ...settings, externalSources: Array.isArray(settings.externalSources)
          ? (settings.externalSources as Row[]).filter(source => source.listingRecordId !== id) : settings.externalSources } };
      });
      return next;
    });
  }
  for (const queryKey of [['assets', 'listing-images', id], ['assets', 'listing-videos', id], ['final-approval-detail', id]]) {
    void client.cancelQueries({ queryKey });
    client.removeQueries({ queryKey });
  }
}
